import Configuration from '../configuration.js';

function buildPdfUrl(numeroAnfr, checkCode) {
  return `${Configuration.getPrtvPdf}?numeroanfr=${numeroAnfr}&checkcode=${checkCode}`;
}

function buildPdfUrl(numeroAnfr, checkCode, deEnvoyee) {
  return `${Configuration.getPrtvPdf}?numeroanfr=${numeroAnfr}&checkcode=${checkCode}&deenvoyee=${deEnvoyee}`;
}

function openPdfUrl(numeroAnfr, checkCode) {
  window.open(buildPdfUrl(numeroAnfr, checkCode), '_blank');
}

function openPdfUrl(numeroAnfr, checkCode, deEnvoyee) {
  window.open(buildPdfUrl(numeroAnfr, checkCode, deEnvoyee), '_blank');
}

export default {
  buildPdfUrl,
  openPdfUrl,
};



// WEBPACK FOOTER //
// ./src/utils/pdf.util.js